module.exports = __webpack_public_path__ + "img/slider-9.b007ee6d.jpg";